import axios from 'axios';
import headers from "./Header";

let ORGANIZATION = "/organization"

class MainService {
    getOrganizationList() {
        let url = 'organization'
        return axios.get(url, {
            headers: headers(),
        });
    }
    getOrganizationByWilayah(name, provinceCode, cityCode) {
        let url = 'organization?size=20&page=0';
        if(name){ url += '&name='+name}
        if(provinceCode){ url += '&provinceCode='+provinceCode}
        if(cityCode){ url += '&cityCode='+cityCode}
        return axios.get(url, {
            headers: headers(),
        });
    }
    getOrganizationById(id) {
        let url = 'organization?id='+id
        return axios.get(url, {
            headers: headers(),
        });
    }
    getData(query) {
        return axios.get(ORGANIZATION + "/" + query, {
            headers: headers(),
        });
    }
    postData(query, data) {
        return axios.post(ORGANIZATION + "/" + query, data, {
            headers: headers(),
        });
    }
    putData(query, data) {
        return axios.put(ORGANIZATION + "/" + query, data, {
            headers: headers(),
        });
    }
    deleteData(id) {
        return axios.delete(ORGANIZATION + "/" + id, {
            headers: headers()
        })
    }
}

export default new MainService();